const classMap = {
  active: 'has-active',
  dropdown: 'js-dropdown',
  menu: 'js-dropdown-menu',
  expand: 'js-dropdown-expand',
  retract: 'js-dropdown-retract',
}

class Dropdown {
  constructor(element) {
    this.dropdown =
      typeof element === 'string'
        ? document.querySelector(`.${element}`)
        : element

    if (this.dropdown) {
      this.menu = this.dropdown.querySelector(`.${classMap.menu}`)
      this.expand = this.dropdown.querySelector(`.${classMap.expand}`)
      this.retract = this.dropdown.querySelector(`.${classMap.retract}`)

      // set aria-expanded on button toggle
      this.expand.setAttribute('aria-expanded', false)

      this.expand.addEventListener(
        'focusin',
        this.onDropToggle.bind(this, true)
      )
      this.dropdown.addEventListener(
        'mouseover',
        this.onDropToggle.bind(this, true)
      )
      this.dropdown.addEventListener(
        'mouseleave',
        this.onDropToggle.bind(this, false)
      )

      if (this.retract) {
        this.retract.addEventListener(
          'click',
          this.onDropToggle.bind(this, false)
        )
      }

      this.getMenuAnchor()
    }
  }

  getMenuAnchor() {
    const that = this
    this.menu.querySelectorAll('a[href]').forEach(function href(anchor) {
      anchor.addEventListener('focusout', (event) => {
        const { currentTarget } = event
        that.onAnchorFocus(currentTarget)
      })
    })
  }

  onDropToggle(opened) {
    const activated =
      opened && this.expand.getAttribute('aria-expanded') === 'true'

    /**
     * prevent several mouseout event
     */

    if (activated) return

    /**
     * dispatch CustomEvent opened
     */

    if (opened) this.dispatchCustomEvent()

    /**
     * toggle dropdown
     */

    this.expand.setAttribute('aria-expanded', opened)
    this.dropdown.classList.toggle(classMap.active, opened)
  }

  dispatchCustomEvent() {
    this.dropdown.dispatchEvent(
      new CustomEvent('opened', {
        bubbles: true,
        cancelable: true,
      })
    )
  }

  onAnchorFocus(anchor) {
    const HAS_NEXT_ELEMENT = anchor.closest('li').nextElementSibling

    if (!HAS_NEXT_ELEMENT) {
      this.onDropToggle(false)
    }
  }

  static mount() {
    const dropdown = document.querySelectorAll(`.${classMap.dropdown}`)
    if (dropdown.length <= 0) return

    dropdown.forEach((drop) => {
      return new Dropdown(drop)
    })
  }
}

export default Dropdown
